import { useEffect, useState } from 'react';

import { ITimeMachineParams } from '../modules/stepper/TimeMachineStepper';

const TIME_MACHINE_DATE_TIME_KEY = 'timeMachineDateTime';
const INITIAL_SNAPSHOT_PARAMS: ITimeMachineParams = {
  date: '',
  time: '',
  channel: '',
};

export const useTimeMachineParams = () => {
  const [timeMachineParams, setTimeMachineParams] = useState(
    INITIAL_SNAPSHOT_PARAMS,
  );

  const onTimeMachineParamsChange = (key: string, value: string) => {
    setTimeMachineParams({ ...timeMachineParams, [key]: value });
  };

  const resetTimeMachineParams = () => {
    setTimeMachineParams(INITIAL_SNAPSHOT_PARAMS);
  };

  useEffect(() => {
    if (!!timeMachineParams.date && !!timeMachineParams.time) {
      const dateTime = `${timeMachineParams.date}T${timeMachineParams.time}`;
      localStorage.setItem(TIME_MACHINE_DATE_TIME_KEY, dateTime);
    }

    return () => {
      localStorage.removeItem(TIME_MACHINE_DATE_TIME_KEY);
    };
  }, [timeMachineParams.date, timeMachineParams.time]);

  useEffect(() => {
    if (!!timeMachineParams.channel) {
      (window as any).environment.channelName = timeMachineParams.channel;
    }

    return () => {
      delete (window as any).environment.channelName;
    };
  }, [timeMachineParams.channel]);

  return {
    timeMachineParams,
    onTimeMachineParamsChange,
    resetTimeMachineParams,
  };
};
